var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamurguesa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 23,
    viewBox: "0 0 37 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 4.05882,
    rx: 2,
    fill: "#252525"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9.4707,
    width: 37,
    height: 4.05882,
    rx: 2,
    fill: "#252525"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 18.9414,
    width: 37,
    height: 4.05882,
    rx: 2,
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamurguesa);
export default __webpack_public_path__ + "static/media/hamurguesa.5615dc0719f4e937deaf359bbe2f7982.svg";
export { ForwardRef as ReactComponent };